import { ApiHelper } from '../apiHelper';

/**
 * A helper to wrap API calls and also track them to segment
 * LEGACY, please use ApiHelper directly
 */
export default function useApiHelper() {
  return ApiHelper;
}
